import { useState } from 'react';

const SellerMarketplaceCard = (props: {
    image: string;
    title: string;
    author: string;
    price: string | number;
    weeklyQuantity?: string | number;
    extra?: string;
    offerNumber: string;
    onClick?: () => void;
    isGuest?: boolean;
}) => {
    const { title, author, price, image, extra, weeklyQuantity, offerNumber, onClick, isGuest = false } = props;

    const [imgError, setImgError] = useState(false);
    const showPlaceholder = !image || imgError;

    return (
        <div
            className={`flex min-w-0 cursor-pointer flex-col overflow-hidden rounded-[16px] border border-[#EFE0AE] bg-white font-hanken transition-colors hover:border-[#F9DC5C] ${extra ?? ''}`}
            onClick={onClick}
        >
            {/* Image */}
            <div className="h-[132px] w-full border-b border-[#F0E4C4] bg-[#F6F0E1]">
                {showPlaceholder ? (
                    <div className="flex h-full w-full items-center justify-center px-3 text-center font-newsreader text-[17px] font-medium text-[#8A7A55]">
                        {title}
                    </div>
                ) : (
                    <img src={image} className="h-full w-full object-cover" alt="" onError={() => setImgError(true)} />
                )}
            </div>

            {/* Body */}
            <div className="flex flex-1 flex-col gap-2.5 px-[18px] py-[17px]">
                <span className="text-[12px] font-semibold uppercase tracking-[0.06em] text-[#6E5205]">{author}</span>
                <span className="flex flex-wrap items-baseline gap-2">
                    <span className="font-newsreader text-[19px] font-semibold tracking-[-0.01em] text-[#1A1613]">{title}</span>
                    {offerNumber && <span className="font-jbmono text-[11.5px] text-[#A79E90]">#{offerNumber}</span>}
                </span>
                <div className="mt-auto flex items-end justify-between gap-3 pt-2">
                    <span>
                        <span className="block text-[11.5px] text-[#8A8172]">prix / lead</span>
                        <span className="block text-[15px] font-bold text-[#6E5205]">{isGuest ? '···' : `${price} €`}</span>
                    </span>
                    {weeklyQuantity != null && (
                        <span className="whitespace-nowrap text-[13px] text-[#6B6357]">{weeklyQuantity} leads dispo.</span>
                    )}
                </div>
                <button className="w-full rounded-[10px] border border-[#E6D6BC] bg-[#FFFDF7] py-2.5 text-[13.5px] font-semibold text-[#3B352C] transition-colors hover:border-[#F9DC5C] hover:bg-[#F9DC5C]">
                    Voir l&apos;offre
                </button>
            </div>
        </div>
    );
};

export default SellerMarketplaceCard;
